import { Component, HostBinding, input } from '@angular/core';

@Component({
  selector: 'app-empty-state',
  imports: [],
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.scss',
})
export class EmptyStateComponent {
  message = input.required<string>();
  minHeight = input<string>('200px');

  // Getter so HostBinding reads the resolved value, not the signal reference itself.
  @HostBinding('style.--empty-state-min-height')
  protected get cssMinHeight(): string {
    return this.minHeight();
  }
}
